import React, { cloneElement, useEffect } from 'react';
import { IControlledStore, useStores } from '@monorepo/controlled/src/hooks/use-stores';
import styles from './modal.module.scss';

export interface IModalCloseOptions {
	confirmed?: boolean;
}

export interface IModalInjectProps {
	id: number;
	closeModal?: (options?: IModalCloseOptions) => void;
}

export interface IModal {
	children: JSX.Element;
	id: number;
}

// TODO - RONT css warning error and info fix
export const Modal = (props: IModal) => {
	const { children, id = 0 } = props;
	const { modalsStore } = useStores<IControlledStore>();

	const closeModal = (options?: IModalCloseOptions) => {
		if (!options?.confirmed) {
			modalsStore
				.getModals()
				.find(modal => modal.id === id)
				?.onDismiss?.();
		}
		modalsStore.removeModal(id);
	};

	const handleKeyDownEvent = (e: KeyboardEvent) => {
		if (e.key === 'Escape') {
			closeModal();
		}
	};

	useEffect(() => {
		window.addEventListener('keydown', handleKeyDownEvent);

		return () => {
			window.removeEventListener('keydown', handleKeyDownEvent);
		};
	}, []);

	const smartChildren = React.Children.map(children, child => {
		return cloneElement(child, {
			closeModal,
			id,
		});
	});

	return (
		<div className={styles.overlay} onClick={() => closeModal()}>
			<div className={styles.modalWrapper} onClick={e => e.stopPropagation()}>
				{smartChildren}
			</div>
		</div>
	);
};
